<template>
  <div
    role="separator"
    class="h-5 w-px rounded-[9px] bg-border-subtle"
  />
</template>
